export function transformString(str: any) {
  if (typeof str !== 'string') return ''; // Handle non-string inputs
  return str
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
}
